"use client";

import { ContentLink } from "@components/cms/link/ContentLink";
import { AnalyticsClient } from "@lib/analytics/AnalyticsClient";
import type { ButtonModel } from "@lib/contentful/mappers/parts/button/types";
import { Button, type ButtonProps } from "@ecco/ui/button";
import { ECCOIcon, type ECCOIconProps } from "@ecco/ui/ecco-icon";

type HeroCallToActionsProps = {
    callToActions?: ButtonModel[];
    promotionImage?: string;
    title?: string;
    id?: string;
    slideIndex: number;
    buttonStyle?: Partial<ButtonProps>;
    getButtonProps: (button: ButtonModel) => Pick<ButtonProps, "variant" | "colorScheme">;
    iconProps?: Partial<ECCOIconProps>;
};

export function HeroCallToActions({
    callToActions,
    promotionImage,
    title,
    id,
    slideIndex,
    buttonStyle,
    getButtonProps,
    iconProps,
}: HeroCallToActionsProps) {
    if (!callToActions?.length) {
        return null;
    }

    return (
        <>
            {callToActions.map((button, i) => (
                <Button
                    key={`${button.id}-${i}`}
                    rightIcon={<ECCOIcon name="arrow-right" {...iconProps} />}
                    as={ContentLink}
                    link={button.link}
                    {...getButtonProps(button)}
                    {...buttonStyle}
                    onClick={() =>
                        AnalyticsClient.selectPromotion({
                            image: promotionImage,
                            title,
                            index: slideIndex,
                            id,
                        })
                    }
                >
                    <span>{button.label}</span>
                </Button>
            ))}
        </>
    );
}
